'use strict'

const { createQueuedCmd } = require('redux-serial-effects')

const cmdTypes = require('./cmdTypes')
const actionTypes = require('./actionTypes')

const TYPE = 'DYNAMIC_PAGES'

const executor = recordStore => {
  return {
    type: TYPE,
    execute: cmd => {
      switch (cmd.type) {
        case cmdTypes.SHOULD_GET_NEXT_DYNAMIC_PAGE_URL:
          return recordStore().matchWith({
            Nothing: () => {
              return Promise.reject(
                new Error('Record store service not ready yet')
              )
            },
            Just: async ({ value: service }) =>
              await service.getNextDynamicPage()
          })
        case cmdTypes.SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL:
          return recordStore().matchWith({
            Nothing: () => {
              return Promise.reject(
                new Error('Record store service not ready yet')
              )
            },
            Just: async ({ value: service }) =>
              await service.getPreviousDynamicPage()
          })
      }
    }
  }
}

const getNextDynamicPageCmd = () =>
  createQueuedCmd(
    TYPE,
    {
      type: cmdTypes.SHOULD_GET_NEXT_DYNAMIC_PAGE_URL
    },
    actionTypes.NEXT_DYNAMIC_PAGE_URL_RESULT
  )

const getPreviousDynamicPageCmd = () =>
  createQueuedCmd(
    TYPE,
    {
      type: cmdTypes.SHOULD_GET_PREVIOUS_DYNAMIC_PAGE_URL
    },
    actionTypes.PREVIOUS_DYNAMIC_PAGE_URL_RESULT
  )

module.exports.executor = executor

module.exports.getNextDynamicPageCmd = getNextDynamicPageCmd
module.exports.getPreviousDynamicPageCmd = getPreviousDynamicPageCmd



// WEBPACK FOOTER //
// ./dynamic-pages/executor.js